const API_ROUTES = {
    CONTACTS: 'contacts/',
    CREATE_CONTACT: 'contacts/create/',
    UPDATE_CONTACT: (id) => `contacts/${id}/update/`,
    DELETE_CONTACT: (id) => `contacts/${id}/delete/`,

    GROUPS: 'groups/',
    CREATE_GROUP: 'groups/create/',
    DELETE_GROUP: (id) => `groups/${id}/delete/`,

    GROUP_MEMBERS: 'group-members/',
    ADD_GROUP_MEMBER: 'group-members/add/',
    DELETE_GROUP_MEMBER: (id) => `group-members/${id}/delete/`,

    HISTORY: 'history/',
    CREATE_HISTORY: 'history/create/',
    DELETE_HISTORY: (id) => `history/${id}/delete/`,

    SHARED_CONTACTS: 'contact/shared-contacts/',
    CREATE_SHARED_CONTACT: 'contact/shared-contacts/create/',
    GET_SHARED_CONTACT: (id) => `contact/shared-contacts/${id}/`,
    UPDATE_SHARED_CONTACT: (id) => `contact/shared-contacts/${id}/update/`,
    DELETE_SHARED_CONTACT: (id) => `contact/shared-contacts/${id}/delete/`,
    RESET_SHARED_CONTACT_LINK: (id) => `contact/shared-contacts/${id}/reset-link/`,
    GET_SHARED_CONTACT_BY_UUID: (contactid) => `contact/shared-call/${contactid}/`,
  };

  export default API_ROUTES;
  